"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryItems = void 0;
const React = require("react");
const SlimSection_1 = require("../../../../../../components/base/structure/SlimSection");
const SalesOrderCartItems_1 = require("../../SalesOrderCartItems");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SalesOrderSummaryItems");
const SalesOrderSummaryItems = ({ salesOrder }) => {
    const { salesOrderItems, totalPrice, promotions } = salesOrder;
    return (React.createElement(SlimSection_1.SlimSection, { className: css("") },
        React.createElement(SlimSection_1.SlimSectionHeader, null,
            React.createElement(SlimSection_1.SlimSectionTitle, null, "Items")),
        React.createElement(SlimSection_1.SlimSectionBody, null,
            React.createElement("div", { className: css("container") },
                React.createElement(SalesOrderCartItems_1.SalesOrderCartItems, { salesOrderItems: salesOrderItems, totalPrice: totalPrice, promotions: promotions, editable: false, showTotal: true })))));
};
exports.SalesOrderSummaryItems = SalesOrderSummaryItems;
//# sourceMappingURL=index.js.map